import { CONSTANT } from "../constant/Constant";
import { API_REQUEST } from "./ApiCommon";
export const LINKS = {
  GET_ALL(name) {
    const url = `${CONSTANT.URL}link/`;
    return API_REQUEST("GET", url);
  },
  GET_BY_ID(req) {
    const url = `${CONSTANT.URL}link/${req}`;
    return API_REQUEST("GET", url);
  },
  GET_BY_DATA(req) {
    const url = `${CONSTANT.URL}link/by-data/${req.bride}/${req.groom}/${req.date}`;
    return API_REQUEST("GET", url);
  },
  ADD(data, token) {
    const url = `${CONSTANT.URL}link`;
    return API_REQUEST("POST", url, data, null);
  },
  UPDATE(data, id) {
    const url = `${CONSTANT.URL}link/${id}`;
    return API_REQUEST("PUT", url, data, null);
  },
  DELETE(req, data, token) {
    const url = `${CONSTANT.URL}link/delete/${req}`;
    return API_REQUEST("PUT", url, data, null);
  },
};
